import React from "react";

// components
import Modal, { ModalProps } from "@/shared/Modal";
const SaveSearchModalContent = React.lazy(() => import("./SaveSearchModalContent"));

// assets
import styles from "@/assets/styles/components/Modals/locl-save-search-modal.module.scss";


function SaveSearchModal({ open, title, onCancel, ...rest }: ModalProps) {

  return (
    <Modal
      centered
      forceRender
      title={title}
      open={open}
      footer={null}
      onCancel={onCancel}
      className={styles["locl-save-search-modal"]}
      {...rest}
    >
      <React.Suspense fallback="...">
        {open && <SaveSearchModalContent onCancel={onCancel}/>}
      </React.Suspense>
    </Modal>
  );
}

export default SaveSearchModal;
